// extracted by mini-css-extract-plugin
module.exports = {"button":"ComplianceModal_button__g9Zfm"};